<template>
  <div class="menu-manage-widget-edit relative">
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="菜单栏背景">
      <menu-fill :target="model.menuBackground" target-key="menuBackground" />
    </menu-item>
    <menu-item label="选中项背景">
      <menu-fill :target="model.activeBackground" target-key="activeBackground" />
    </menu-item>
    <menu-item label="选中项文字色">
      <menu-fill :target="model.activeColor" target-key="activeColor" />
    </menu-item>
    <menu-item label="未选中项背景">
      <menu-fill :target="model.inactiveBackground" target-key="inactiveBackground" />
    </menu-item>
    <menu-item label="未选中项文字色">
      <menu-fill :target="model.inactiveColor" target-key="inactiveColor" />
    </menu-item>
    <menu-item label="圆角">
      <menu-slider v-model="model.borderRadius" target-key="borderRadius" />
    </menu-item>
    <menu-item label="菜单项">
      <nav-add :model="model" :site="site" :max-length="10" :hide-funs="['jumpLink']" :filter-modules="filterModules" :menu-sections="{ selectModule: true }" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import menuItem from '~/components/menu/menuItem.vue'
import menuFill from '~/components/menu/menuFill.vue'
import NavAdd from "~/components/menu/navAdd"
import menuSlider from '~/components/menu/menuSlider.vue'
import { WidgetModelNames } from '~/enums/siteEnum'

const props = defineProps({
  model: Object,
  site: Object
})

const filterModules = computed(() => {
  return [WidgetModelNames.PwaSettingWidgetModel, WidgetModelNames.MissionCenterSettingModel, WidgetModelNames.SupportSettingWidgetModel]
})
</script>

<style lang="less">
</style>